import { defineSlotRecipe } from "@chakra-ui/react";
import { fieldAnatomy } from "@chakra-ui/react/anatomy";

const fieldRecipe = defineSlotRecipe({
  slots: fieldAnatomy.keys(),
  base: {
    root: {
      gap: "0",
    },
    label: {
      mb: "2",
      lineHeight: "1.5",
      _disabled: {
        opacity: 1,
      },
    },
    requiredIndicator: {
      color: "brand.error",
      lineHeight: "inherit",
    },
  },
});

export default fieldRecipe;
